import { render, staticRenderFns } from "./ExtraCost.vue?vue&type=template&id=58e49bba&scoped=true&"
import script from "./ExtraCost.vue?vue&type=script&lang=js&"
export * from "./ExtraCost.vue?vue&type=script&lang=js&"
import style0 from "./ExtraCost.vue?vue&type=style&index=0&id=58e49bba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e49bba",
  null
  
)

export default component.exports